module.exports = __webpack_public_path__ + "media/images/lb/095-35c464511de9c8f48bb15961f0860dc0.svg";